export const ADD_TOAST = 'toasts/add-toast';
export const REMOVE_TOAST = 'toasts/remove-toast';
